import React, {
  createRef,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import axios from 'axios';

import styles from './pod-management.module.scss';
import '@fortawesome/fontawesome-free';
import 'components-font-awesome';
import { rootUrl } from '../../config';
import importantIcon from '../../assets/images/pods/icons/Warning.svg';
import trashIcon from '../../assets/images/pods/icons/Delete.svg';
import editIcon from '../../assets/images/pods/icons/Edit.svg';
import zoomIcon from '../../assets/images/pods/icons/Search.svg';
import closeIcon from '../../assets/images/pods/icons/Close.svg';

import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core';
import { DataGrid, GridOverlay } from '@material-ui/data-grid';
// import { SpeedDial, SpeedDialAction, SpeedDialIcon } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  rootEmpty: {
    flexDirection: 'column',
    '& .ant-empty-img-1': {
      fill: theme.palette.type === 'light' ? '#aeb8c2' : '#262626',
    },
    '& .ant-empty-img-2': {
      fill: theme.palette.type === 'light' ? '#f5f5f7' : '#595959',
    },
    '& .ant-empty-img-3': {
      fill: theme.palette.type === 'light' ? '#dce0e6' : '#434343',
    },
    '& .ant-empty-img-4': {
      fill: theme.palette.type === 'light' ? '#fff' : '#1c1c1c',
    },
    '& .ant-empty-img-5': {
      fillOpacity: theme.palette.type === 'light' ? '0.8' : '0.08',
      fill: theme.palette.type === 'light' ? '#f5f5f5' : '#fff',
    },
  },
  label: {
    marginTop: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  table: {
    minWidth: 650,
  },
  inputWrapper: {
    maxWidth: 300,
    textAlign: 'left',
    margin: '20px 10px',
    '& .MuiOutlinedInput-input': {
      padding: '6px 14px',
      paddingRight: 32,
    },
  },
  red: {
    color: 'red',
  },
  grid: {
    borderRadius: 0,
    '& .MuiDataGrid-colCellWrapper': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
      '& .MuiDataGrid-colCellTitle': {
        color: 'rgba(113, 59, 144, 1)',
        fontWeight: 900,
      },
    },
    '& .MuiDataGrid-window': {
      backgroundColor: 'white',
    },
    '& .MuiTablePagination-selectRoot': {
      lineHeight: '.2rem',
    },
  },
  speedDial: {
    '& .MuiSpeedDial-fab': {
      backgroundColor: 'rgba(113, 59, 144, 1)',
      width: 36,
      height: 28,
    },
  },
  speedAction: {
    color: 'rgba(113, 59, 144, 1)',
  },
  gold: {
    color: 'gold',
  },
  statusColumn: {
    display: 'inline',
    minWidth: 60,
    fontFamily: "'Archivo Narrow'",
  },
  filterBar: {
    display: 'flex',
    flexDirection: 'vertical',
  },
  filterInput: {
    maxWidth: 300,
  },
}));

const CustomLoadingOverlay = () => {
  return (
    <GridOverlay>
      <div style={{ position: 'absolute', top: 0, width: '100%' }}>
        <LinearProgress />
      </div>
    </GridOverlay>
  );
};

const CustomNoRowsOverlay = () => {
  const classes = useStyles();
  return (
    <GridOverlay className={classes.rootEmpty}>
      <svg
        width="120"
        height="100"
        viewBox="0 0 184 152"
        aria-hidden
        focusable="false"
      >
        <g fill="none" fillRule="evenodd">
          <g transform="translate(24 31.67)">
            <ellipse
              className="ant-empty-img-5"
              cx="67.797"
              cy="106.89"
              rx="67.797"
              ry="12.668"
            />
            <path
              className="ant-empty-img-1"
              d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
            />
            <path
              className="ant-empty-img-2"
              d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
            />
            <path
              className="ant-empty-img-3"
              d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
            />
          </g>
          <path
            className="ant-empty-img-3"
            d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
          />
          <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
            <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
            <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
          </g>
        </g>
      </svg>
      <div className={classes.label}>No Rows</div>
    </GridOverlay>
  );
};

const actions = [
  {
    icon: <img src={editIcon} alt="edit pod" />,
    name: 'Edit Pod',
  },
  {
    icon: <img src={trashIcon} alt="delete pod" />,
    name: 'Delete Pod',
  },
];

const statuses = ['Active', 'Inactive', 'New'];

const statusItems = () => {
  const items = [];
  items.push(
    <MenuItem key={'null'} value={null}>
      <em>Status</em>
    </MenuItem>
  );
  statuses.forEach((s) =>
    items.push(
      <MenuItem key={s} value={s}>
        {s}
      </MenuItem>
    )
  );
  return items;
};

const PodManagement = (props) => {
  const {
    history,
    pods,
    setPods,
    // loaded,
    // setLoaded,
    tab,
    me,
    setSnacking,
    setMessage,
    setSeverity,
  } = props;
  const classes = useStyles();
  const [filteredPods, setFilteredPods] = useState(pods);
  const [gridHeight, setGridHeight] = useState(500);
  const boxRef = createRef(null);
  // const [open, setOpen] = useState(null);
  const [filterText, setFilterText] = useState('');
  const [status, setStatus] = useState(null);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [activePod, setActivePod] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const applyFilter = useCallback(
    (text, status) => {
      try {
        let filtered = pods;
        //filter logic here
        if (text) {
          filtered = filtered.filter(
            (p) =>
              p.name?.toLowerCase().includes(text.toLowerCase()) ||
              p.country?.toLowerCase().includes(text.toLowerCase()) ||
              p.state?.toLowerCase().includes(text.toLowerCase()) ||
              p.city?.toLowerCase().includes(text.toLowerCase())
          );
        }

        if (status) {
          filtered = filtered.filter(
            (p) => p.status.toLowerCase() === status.toLowerCase()
          );
        }

        setFilteredPods(filtered);
      } catch (error) {
        console.error(error);
      }
    },
    [pods]
  );

  useEffect(() => {
    applyFilter(filterText, status);
    // setFilteredPods(pods);
  }, [pods, applyFilter, filterText, status]);

  const updatePodCounts = useCallback(
    (pods) => {
      pods.forEach((pod) => {
        if (pod.isNew) {
          pod.status = 'New';
        } else if (pod.podCoordinators.length) {
          pod.status = 'Active';
        } else {
          pod.status = 'Inactive';
        }

        pod.members = pod.podMembers
          .filter((profile) => profile.status === 'approved')
          .flat().length;
        pod.coordinators = pod.podCoordinators.length;
        pod.pending = pod.podMembers
          .filter((profile) => profile.status === 'pending')
          .flat().length;
        pod.rejected = pod.podMembers
          .filter((profile) => profile.status === 'rejected')
          .flat().length;
      });

      setPods(pods);
    },
    [setPods]
  );

  useEffect(() => {
    //whenever tab changed to visible load data
    //updated to get data now to make sure it reflects latest changes from user management tab
    if (tab === 1) {
      setLoaded(false);
      axios
        .get(`${rootUrl}/api/all-pods`, { withCredentials: true })
        .then(({ data }) => {
          //order data by default to show Status of New first,
          const sorted = data?.filter((pod) => pod.isNew);
          //then pods with pending profiles,
          sorted.push(
            data?.filter(
              (pod) =>
                !pod.isNew &&
                pod.podMembers
                  .filter((profile) => profile.status === 'pending')
                  .flat().length > 0
            )
          );
          //then the rest
          sorted.push(
            data?.filter(
              (pod) =>
                !pod.isNew &&
                pod.podMembers
                  .filter((profile) => profile.status === 'pending')
                  .flat().length === 0
            )
          );
          updatePodCounts(sorted.filter((a) => a).flat());
          setLoaded(true);
        });
    }
  }, [tab, updatePodCounts]);

  useEffect(() => {
    if (boxRef.current) {
      const h = boxRef.current.clientHeight + 100;
      if (h !== gridHeight) {
        setGridHeight(h);
      }
    }
  }, [boxRef, gridHeight]);

  const filterKeyed = (e) => {
    if (e.keyCode === 13) {
      applyFilter(filterText, status);
    }
  };

  const filterChanged = (e) => {
    const val = e.target.value;
    setFilterText(val);
    applyFilter(val, status);
  };

  const clearFilter = () => {
    setFilterText('');
    applyFilter('', status);
  };

  const speedyClick = useCallback(
    (e, action, pod) => {
      // handleClose();
      setActivePod(pod);

      if (action.name === 'Edit Pod') {
        history.push('/pods/' + pod.id);
      } else if (action.name === 'Delete Pod') {
        // confirm
        setOpenDeleteConfirm(true);
      }
    },
    [history]
  );

  const handleDialogClose = () => {
    setActivePod(null);
    setOpenDeleteConfirm(false);
  };

  const deletePod = () => {
    axios
      .post(
        `${rootUrl}/api/pod/delete`,
        {
          id: activePod.id,
        },
        { withCredentials: true }
      )
      .then((results) => {
        if (results.status === 200 && results.data) {
          // remove user from model
          const updatePods = [...pods];
          const index = updatePods.findIndex((u) => u.id === activePod.id);
          updatePods.splice(index, 1);
          setPods(updatePods);

          setMessage('Pod Deleted!');
          setSeverity('success');
          setSnacking(true);
          setActivePod(null);
          setOpenDeleteConfirm(false);
        }
      });
  };

  const dataGrid = useMemo(() => {
    return (
      <DataGrid
        autoHeight={true}
        pageSize={15}
        className={classes.grid}
        rowsPerPageOptions={[5, 15, 50, 100]}
        pagination
        components={{
          loadingOverlay: CustomLoadingOverlay,
          noRowsOverlay: CustomNoRowsOverlay,
        }}
        loading={!loaded}
        columns={[
          { field: 'id', hide: true },
          {
            field: 'name',
            headerName: 'Pod Name',
            headerClassName: styles.tableHeader,
            cellClassName: styles.tableBody,
            align: 'left',
            width: 200,
          },
          {
            field: 'country',
            headerName: 'Country',
            headerClassName: styles.tableHeader,
            cellClassName: styles.tableBody,
            align: 'left',
            width: 150,
          },
          {
            field: 'state',
            headerName: 'State',
            headerClassName: styles.tableHeader,
            cellClassName: styles.tableBody,
            align: 'left',
            width: 150,
          },
          {
            field: 'city',
            headerName: 'City',
            headerClassName: styles.tableHeader,
            cellClassName: styles.tableBody,
            align: 'left',
            width: 150,
          },
          {
            field: 'status',
            headerName: 'STATUS',
            headerClassName: styles.tableHeader,
            cellClassName: styles.tableBody,
            width: 100,
            align: 'left',
            renderCell: ({ row }) => (
              <div>
                <Typography className={classes.statusColumn}>
                  {row?.status}
                </Typography>
                {row?.status === 'Active' && (
                  <i className={`fa fa-star ${styles.star}`} alt="star"></i>
                )}
                {row?.status === 'New' && (
                  <img
                    src={importantIcon}
                    className={styles.attention}
                    alt="Important"
                  />
                )}
              </div>
            ),
          },
          {
            field: 'members',
            headerName: 'MEMBERS',
            headerClassName: styles.tableHeader,
            cellClassName: styles.tableBody,
            width: 100,
            align: 'center',
          },
          {
            field: 'coordinators',
            headerName: 'COORDINATORS',
            headerClassName: styles.tableHeader,
            cellClassName: styles.tableBody,
            width: 150,
            align: 'center',
          },
          {
            field: 'pending',
            headerName: 'PENDING',
            headerClassName: styles.tableHeader,
            cellClassName: styles.tableBody,
            width: 100,
            align: 'center',
          },
          {
            field: 'rejected',
            headerName: 'REJECTED',
            headerClassName: styles.tableHeader,
            cellClassName: styles.tableBody,
            width: 100,
            align: 'center',
          },
          {
            field: 'none',
            headerName: 'ACTIONS',
            sortable: false,
            headerClassName: styles.tableHeader,
            width: 250,
            align: 'left',
            renderCell: ({ row }) =>
              actions
                .filter((a) => !row?.isRemote || a.name === 'Edit Pod')
                .map((action) => (
                  <IconButton
                    className={classes.speedAction}
                    key={action.name}
                    title={action.name}
                    onClick={(e) => speedyClick(e, action, row)}
                  >
                    {action.icon}
                  </IconButton>
                )),
          },
        ]}
        rows={(me && me.isAdmin && filteredPods) || []}
      />
    );
  }, [classes, filteredPods, loaded, me, speedyClick]);

  //get pod from query string
  return (
    <Box ref={boxRef} className={styles.container} height="100%">
      <div className="filterBar">
        <FormControl className={classes.inputWrapper}>
          <TextField
            variant="outlined"
            id="filter-input"
            className={classes.filterInput}
            autoComplete="off"
            value={filterText}
            placeholder="Search"
            onKeyDown={filterKeyed}
            onChange={filterChanged}
            InputProps={{
              autoComplete: 'off',
              startAdornment: (
                <InputAdornment position="start">
                  <img src={zoomIcon} alt="search" />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={clearFilter}>
                    <img src={closeIcon} alt="close" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </FormControl>

        <FormControl className={classes.inputWrapper}>
          <Select
            id="status-select"
            variant="outlined"
            value={status}
            displayEmpty
            onChange={(e) => {
              setStatus(e.target.value);
              applyFilter(filterText, e.target.value);
            }}
          >
            {statusItems()}
          </Select>
        </FormControl>
      </div>
      {dataGrid}
      <Dialog
        open={openDeleteConfirm}
        onClose={handleDialogClose}
        aria-labelledby="pod-dialog-delete"
      >
        <DialogTitle id="pod-dialog-delete">Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you certain you want to completely delete the {activePod?.name}{' '}
            Pod?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={`user ${styles.cancelButton}`}
            onClick={handleDialogClose}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            className={`user ${styles.purpleButton}`}
            onClick={deletePod}
            color="primary"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PodManagement;
